export const JobRequisitionStatusEnums = {
  external: {
    key: 1,
    value: "external",
  },
  internal: {
    key: 2,
    value: "internal",
  },
};
